import { useAuth } from "@/contexts/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Users } from "lucide-react";

// Top-of-sidebar dropdown that workers use to switch which client they're acting for.
// Only renders for workers with 2+ engagements.
export default function ClientSwitcher() {
  const { user, clients, activeClientId, setActiveClientId } = useAuth();
  if (!user || user.role !== "worker") return null;
  if (!clients || clients.length < 2) return null;
  const value = activeClientId || (clients.find((c) => c.active)?.client_id ?? clients[0].client_id);

  return (
    <div className="px-4 pb-3" data-testid="client-switcher">
      <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-muted-foreground mb-1.5 flex items-center gap-1">
        <Users className="w-3 h-3" /> Acting for client
      </div>
      <Select value={value} onValueChange={setActiveClientId}>
        <SelectTrigger className="rounded-2xl min-h-[44px] font-bold" data-testid="client-switcher-trigger">
          <SelectValue />
        </SelectTrigger>
        <SelectContent data-testid="client-switcher-content">
          {clients.map((c) => (
            <SelectItem key={c.client_id} value={c.client_id} data-testid={`client-option-${c.client_id}`}>
              <div className="flex items-center justify-between w-full gap-3">
                <span className="truncate">{c.client_name || c.client_email}</span>
                {!c.is_subscriber && (
                  <span className="text-[10px] uppercase tracking-wider font-bold text-destructive">Unpaid</span>
                )}
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
